import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../services/api";
import { getErrorAsList } from "../utils";

const initialState = {
  loading: false,
  error: undefined,
  teamList: [],
};

export const getAllTeams = createAsyncThunk("teams/getAllTeams", async (args, thunkAPI) => {
  try {
    const { data } = await api.get("/api/teams/");
    return data;
  } catch (error) {
    console.error(error);
    return thunkAPI.rejectWithValue(getErrorAsList(error));
  }
});

export const teamSlice = createSlice({
  name: "team",
  initialState,
  extraReducers: {
    // Get all
    [getAllTeams.pending]: (state) => {
      state.loading = true;
    },
    [getAllTeams.fulfilled]: (state, action) => {
      state.loading = false;
      state.error = undefined;
      state.teamList = action.payload;
    },
    [getAllTeams.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export default teamSlice.reducer;
